import { Link } from "react-router-dom";
import type { Movie } from "@/lib/media";
import { typeLabels } from "@/mocks/site";

interface MovieCardProps {
  movie: Movie;
  className?: string;
}

export default function MovieCard({ movie, className = "" }: MovieCardProps) {
  return (
    <Link to={`/detail/${movie.id}`} className={`group block ${className}`}>
      <div className="relative aspect-[2/3] w-full overflow-hidden rounded-lg border border-background-200 bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title}海报`}
          title={`${movie.title} ${movie.year} 影片详情 色虎`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.05]"
        />
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-primary-950/95 via-primary-950/35 to-transparent px-3 pb-2.5 pt-10">
          <div className="flex items-center justify-between gap-2">
            <span className="rounded bg-accent-500 px-1.5 py-0.5 font-heading text-xs font-bold text-primary-950">
              {movie.rating.toFixed(1)}
            </span>
            <span className="truncate text-[11px] text-background-100">
              {movie.year} · {typeLabels[movie.type]}
            </span>
          </div>
        </div>
        <span className="absolute left-2 top-2 rounded bg-primary-900/80 px-1.5 py-0.5 text-[10px] font-medium text-background-100 backdrop-blur">
          {movie.status}
        </span>
      </div>
      <h3 className="mt-2.5 truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-accent-600">
        {movie.title}
      </h3>
      <p className="mt-1 truncate text-xs text-foreground-500">{movie.genres.join(" / ")}</p>
    </Link>
  );
}